import { createRouter } from '@tanstack/react-router'
import { BASE_PATH } from '@/lib/env'
import { routeTree } from './routeTree.gen'

const basePath = BASE_PATH || '/'

export const router = createRouter({
  routeTree,
  basepath: basePath, // TanStack Routerのベースパス
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
})

// デバッグ用ログ
console.log(`🛣️ Router initialized with basepath: ${basePath}`)
